import { RootState } from "store/store";

export const selectHotelPriceInfo = (state: RootState) => (hotelID: string) => {
  const info = state.hotels.prices[hotelID];
  return info ?? undefined;
};
